/** Rota inicial após login ou ao acessar `/`. */
export function getDefaultHomePath(roles: string[]): string {
  if (roles.includes('Admin')) {
    return '/campaigns/dashboard';
  }

  if (roles.includes('Seller') || roles.includes('TeamLeader')) {
    return '/campaigns/my-performance';
  }

  return '/dashboard';
}

/** Respeita deep-link pós-login, exceto home genérica que vira rota por perfil. */
export function resolvePostLoginPath(fromPathname: string | undefined, roles: string[]): string {
  const home = getDefaultHomePath(roles);

  if (!fromPathname || fromPathname === '/' || fromPathname === '/dashboard') {
    return home;
  }

  return fromPathname;
}
